import {
  useFocusRange,
  useVisibleProcesses,
} from "utils/customHooks/genericHooks";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";
import { MAX_TIMELINES_BEFORE_HIDE_INITIALLY } from "constants/constants";
import { DASHBOARD_CARD_PROPS } from "../../dashboardPagesContentUtils";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import Timelines from "components/Dashboard/Timeline/Timelines/Timelines";
import { HighlightTagsSelector } from "components/Dashboard/HubletView/SingleTimeline/HighlightTagsSelector/HighlightTagsSelector";
import { useEffect } from "react";
import ShowTimelineButton from "components/FlightTrends/ShowTimelineButton";
import { useDisplayTimelinePageTimelines } from "../../useDisplayTimelinePageTimelines";
import { useNumProcessesRequiredOnThisPage } from "../../../LoadingIndicatorDashboardPages";
import TimelineCardControls from "components/Dashboard/Timeline/TimelineCardControls/TimelineCardControls";
import { css } from "styled-components/macro";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";
import Spinner from "components/SimpleComponents/Spinner/Spinner";
import {
  AUTO_DOWNLOAD_IMG,
  DownloadTimelineImageButton,
  useIsTakingSnapshot,
} from "pages/SnapshotsPage/SnapshotElementButton";

export function TimelineChartCard() {
  const { translate } = useFlightTranslation();
  const [isTakingSnapshot] = useIsTakingSnapshot();

  const isTakingSnapshotOfTimeline =
    isTakingSnapshot &&
    window.location.search.includes(
      `autoDownload=${AUTO_DOWNLOAD_IMG.timeline}`
    );

  return (
    <CardWithControls
      title={translate("Group_Timeline")}
      className={"Card_GroupTimeline break-before"}
      {...DASHBOARD_CARD_PROPS}
      collapsible={true}
      // need overflow visible for the timeline tooltip to show up
      customCss={css`
        overflow: visible;
        .cardContent {
          padding-top: 10px;
        }
        ${isTakingSnapshotOfTimeline
          ? css`
              .TimeAxisStyles {
                padding: 0 10px;
              }
            `
          : ""}
      `}
      CardConfigControls={<TimelineCardControls />}
      forceExpanded={isTakingSnapshotOfTimeline}
    >
      <DownloadTimelineImageButton />
      <TimelinesSection />
    </CardWithControls>
  );
}
function TimelinesSection() {
  const [showTimelines, setShowTimelines] = useDisplayTimelinePageTimelines();

  const focusRange = useFocusRange();
  const visibleProcesses = useVisibleProcesses();
  const numProcessesRequiredOnThisPage = useNumProcessesRequiredOnThisPage();
  useEffect(() => {
    // hide timeline when num processes is > threshold, and when focus range changes
    if (
      visibleProcesses.length > MAX_TIMELINES_BEFORE_HIDE_INITIALLY &&
      !window.location.pathname.includes("fromSnapshots")
    ) {
      setShowTimelines(false);
    } else if (
      // show timeline if we're finished loading & num processes is under the threshold
      visibleProcesses.length >= numProcessesRequiredOnThisPage &&
      visibleProcesses.length <= MAX_TIMELINES_BEFORE_HIDE_INITIALLY
    ) {
      setShowTimelines(true);
    }
  }, [
    visibleProcesses,
    focusRange,
    setShowTimelines,
    numProcessesRequiredOnThisPage,
  ]);

  const [
    {
      general: { timelinePageShowTagHighlight },
    },
  ] = useFlightConfig();
  const ready = visibleProcesses.length > 0;
  return !ready ? (
    <div style={{ padding: "24px 0 24px" }}>
      <Spinner width={24} />
    </div>
  ) : showTimelines ? (
    <>
      <Timelines />
      {timelinePageShowTagHighlight && <HighlightTagsSelector />}
    </>
  ) : (
    <ShowTimelineButton
      onClick={() => setShowTimelines(true)}
      showNote={true}
    />
  );
}
